import {QueryRouteQueryType} from '@github-ui/react-core/future/data-router-types'

import {pullRequestsAppBuilder} from '../config/app-builder'

export const {pullRequestsLayoutRoute} = pullRequestsAppBuilder.createQueryRouteConfig('pullRequestsLayoutRoute', {
  path: '/:owner/:repo/pull/:pr_number/commits',
  queries: [
    {
      queryName: 'layoutPayload',
      queryFn: async () => {
        return {
          layoutSomeField: '{loaded via query `layoutPayload`}',
        }
      },
      type: QueryRouteQueryType.Blocking,
    },
  ],
})
